<!-- <div *ngIf="isloader" class="h-100 w-100 padt-5">
    <mat-progress-bar [mode]="'indeterminate'"> </mat-progress-bar>
</div> -->
<div class="h-100 w-100 padt-5 container-scans cursor">
    <div class="vehicle-profile-header widget-title">{{widgetData?.title}}</div>
    <div class="low-battery-count">
        <div class="d-flex align-items-center">
            <div class="patient-count-value ml-auto">190 sec</div>
            <div class="ml-auto low-battery-alert-count-tile-size">
                <img src="../../../../assets/images/up arrow.svg" class="h-38" alt="up-arrow">
            </div>
        </div>
    </div>
</div>
